module.exports = __webpack_public_path__ + "media/images/marker-47b6008cab38d6d6c184e97a3514ba89.png";